const rawApiBase = process.env.REACT_APP_BACKEND_URL?.trim();
const API = (rawApiBase || '').replace(/\/+$/, '');

export function buildApiUrl(path = '') {
  if (!path) {
    return API;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  if (!API) {
    return path;
  }

  return `${API}${path.startsWith('/') ? path : `/${path}`}`;
}

export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') {
    return url || '';
  }

  if (/^(data:|blob:|https?:\/\/)/i.test(url)) {
    return url;
  }

  return buildApiUrl(url);
}
